module.exports = __webpack_public_path__ + "img/location.65883bc.svg";